import { visibleFocus } from '../../../identity';
import { css } from '../../../styled-components';
import { ButtonSize } from '../utils';
const buttonBgColor = (theme, light, accent, disabled) => {
  var _theme$colors$brand$s;
  if (light) {
    return disabled ? theme.colors.tints.gray['10'] : theme.colors.tints.gray[40];
  }
  if (accent) {
    return disabled ? theme.colors.tints.gray['40'] : theme.colors.brand.accent[100];
  }
  return disabled ? theme.colors.tints.gray['40'] : ((_theme$colors$brand$s = theme.colors.brand.specialRialtoElementsColor) === null || _theme$colors$brand$s === void 0 ? void 0 : _theme$colors$brand$s[100]) || theme.colors.brand.primary[100];
};
const buttonHoverColor = (theme, light) => {
  var _theme$colors$brand$s2, _theme$colors$brand$s3;
  return light ? theme.colors.tints.gray['40'] : (_theme$colors$brand$s2 = theme.colors.brand.specialRialtoElementsColor) !== null && _theme$colors$brand$s2 !== void 0 && _theme$colors$brand$s2[100] ? `${(_theme$colors$brand$s3 = theme.colors.brand.specialRialtoElementsColor) === null || _theme$colors$brand$s3 === void 0 ? void 0 : _theme$colors$brand$s3[100]}cc` : theme.colors.brand.secondary[100];
};
export const paddingSwitcher = (theme, size) => {
  switch (size) {
    case ButtonSize.small:
      return `6px ${theme.spacings.small} 4px`;
    case ButtonSize.large:
      return `16px ${theme.spacings.large} 14px`;
    case ButtonSize.normal:
      return `5px 12px`;
    default:
      throw new RangeError(`Enum ${size} is not defined.`);
  }
};
export const mgbStyles = css`
  display: inline-block;
  height: fit-content;
  margin-bottom: 0;
  font-family: ${({
  theme: {
    fonts
  }
}) => fonts.families.condensed};
  font-weight: ${({
  theme: {
    fonts
  }
}) => fonts.weights.medium};
  ${({
  uppercase
}) => uppercase ? 'text-transform: uppercase;' : ''}
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  white-space: nowrap;
  padding: ${({
  size,
  theme
}) => paddingSwitcher(theme, size || ButtonSize.normal)};
  font-size: ${({
  size,
  theme: {
    fonts: {
      sizes
    }
  }
}) => size === ButtonSize.small ? sizes.text.xsmall : size === ButtonSize.large ? sizes.text.small : sizes.text.small};
  line-height: 100%;
  transition:
    background-color 100ms linear,
    color 100ms linear,
    border 100ms linear;
  color: ${({
  light,
  accent,
  disabled,
  outline,
  theme
}) => outline ? buttonBgColor(theme, light, accent, disabled) : light ? theme.colors.tints.gray['60'] : theme.colors.tints.white['100']};
  border: ${({
  light,
  accent,
  disabled,
  theme
}) => `2px solid ${buttonBgColor(theme, light, accent, disabled)}`};
  border-radius: ${({
  theme: {
    borderRadiuses
  }
}) => borderRadiuses.small};
  background-color: ${({
  light,
  accent,
  disabled,
  outline,
  theme
}) => outline ? 'transparent' : buttonBgColor(theme, light, accent, disabled)};
  outline-offset: -1px;
  text-decoration: none;

  ${({
  disabled,
  light,
  outline,
  theme
}) => !disabled ? css`
          &:hover,
          &:focus {
            background-color: ${outline ? 'inherit' : buttonHoverColor(theme, light)};
            color: ${outline ? buttonHoverColor(theme, light) : light ? theme.colors.tints.gray['60'] : theme.colors.tints.white['100']};
            border-color: ${buttonHoverColor(theme, light)};
          }
        ` : css`
          &:hover {
            cursor: not-allowed;
          }
        `}

  ${visibleFocus()}
`;